import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonIcon } from 'components/button';
import { Button } from 'components/cosmos';
import { Loader } from 'components/loader';
import { Modal } from 'components/modal';
import { I18n, translate } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import { inject, observer } from 'mobx-react';
import { sendEventCommentClassStatus } from 'modules/app/services/datahubEvents/moderationSupport/tryCommentClassStatus/utils';
import { CommunityService } from 'modules/community';
import CommentListService from 'modules/community/commentList/CommentListService';
import CommentChat from 'modules/community/commons/CommentChat';
import { DEFAULT_PAGE_SIZE } from 'modules/community/constants';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import './ContextModal.scss';

export class ContextModal extends Component {
  static propTypes = {
    t: PropTypes.func,
    hash: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    commentSelected: PropTypes.shape({
      commentClass: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
      }),
      commentDate: PropTypes.string,
      content: PropTypes.string,
      id: PropTypes.string,
      parentId: PropTypes.string,
      lastAction: PropTypes.string,
      page: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        module: PropTypes.string
      }),
      status: PropTypes.string,
      type: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string
      })
    }),
    onClose: PropTypes.func
  };

  state = {
    loading: true,
    contextCommentList: [],
    loadMoreComments: false,
    showMoreComments: {},
    answerListText: {},
    answerBoxOpened: {},
    topicComment: {}
  };

  modalRef = React.createRef();

  constructor(props) {
    super(props);

    this.commentAnswerReply = this.commentAnswerReply.bind(this);
    this.redirectHistoricScreen = this.redirectHistoricScreen.bind(this);
    this.getHistoryReply = this.getHistoryReply.bind(this);
    this.renderModalBody = this.renderModalBody.bind(this);
    this.getMoreComments = this.getMoreComments.bind(this);
    this.renderContextAnswers = this.renderContextAnswers.bind(this);
    this.commentStatusUpdate = this.commentStatusUpdate.bind(this);
    this.getTopicComment = this.getTopicComment.bind(this);
    this.showMore = this.showMore.bind(this);
    this.toogleAnswer = this.toogleAnswer.bind(this);
    this.onAnswerText = this.onAnswerText.bind(this);

    this.viewAsProducerIsAllowed = CommunityService.viewAsProducerIsAllowed;
  }

  componentDidMount() {
    this.getTopicComment();
  }

  async getTopicComment() {
    const { commentSelected } = this.props;

    const commentId = commentSelected.parentId || commentSelected.id;

    this.setState({ loading: true });

    const topicComment = await CommunityService.getCommentbyId(commentId);

    if (topicComment) {
      this.setState({ topicComment });

      this.getHistoryReply(DEFAULT_PAGE_SIZE);
    } else {
      CommunityService.getCommunityNotifications();
    }

    this.setState({ loading: false });
  }

  async getHistoryReply(size = DEFAULT_PAGE_SIZE) {
    const { commentSelected } = this.props;

    const parent = commentSelected.parentId || commentSelected.id;
    const userId = commentSelected.user.id;

    this.setState({ loading: true });

    const params = {
      sort: 'createDate,asc',
      page: 0,
      size
    };

    const response = await CommunityService.getHistoryReply(
      parent,
      userId,
      params
    );

    CommunityService.getCommunityNotifications();

    if (response) {
      this.setState({
        contextCommentList: response.content,
        loadMoreComments: response.totalElements > response.numberOfElements
      });
    }

    this.setState({ loading: false });
  }

  async commentStatusUpdate(item, status) {
    try {
      const { topicComment } = this.state;

      await CommentListService.commentStatusUpdate(item, status);

      if (topicComment.id === item.id) {
        this.getTopicComment();
      } else {
        this.getHistoryReply();
      }

      sendEventCommentClassStatus({
        status,
        comment: item
      });
    } catch (error) {
      sendEventCommentClassStatus({
        isSuccess: false,
        status,
        failureDescription: error,
        comment: item
      });
    }
  }

  async getMoreComments() {
    const { contextCommentList } = this.state;

    await this.getHistoryReply(DEFAULT_PAGE_SIZE + contextCommentList.length);

    const current = this.modalRef.current;

    current.scrollTo(0, current.scrollHeight);
  }

  async commentAnswerReply(answerData, content) {
    const commentId = answerData && answerData.id;
    const commentUserId = answerData && answerData.user && answerData.user.id;
    const { hash: userId } = this.props;

    const response = await CommunityService.commentAnswerReply(
      userId,
      commentUserId,
      commentId,
      content
    );

    if (response) {
      await this.getHistoryReply();

      UiService.setAlertSuccess('community.send_notification_message_success');
    }
  }

  showMore(answerDataId) {
    const { showMoreComments } = this.state;

    showMoreComments[answerDataId] = true;

    this.setState({ showMoreComments });
  }

  toogleAnswer(answerDataId) {
    const { answerBoxOpened } = this.state;

    answerBoxOpened[answerDataId] = !answerBoxOpened[answerDataId];

    this.setState({ answerBoxOpened });
  }

  onAnswerText(event, answerDataId) {
    const { answerListText } = this.state;

    answerListText[answerDataId] = event.target.value;

    this.setState({ answerListText });
  }

  redirectHistoricScreen() {
    const { commentSelected, history } = this.props;

    history.push(
      ROUTES.COMMUNITY.HISTORY.replace(
        ':commentUserId',
        commentSelected.user.id
      )
    );
  }

  get historicTitle() {
    const { t, commentSelected } = this.props;

    const firstNameIndex = 0;
    const firstName =
      commentSelected.user &&
      commentSelected.user.name &&
      commentSelected.user.name.split(' ')[firstNameIndex];

    return t('community.historic_title', { data: { userName: firstName } });
  }

  renderModalHeader = () => (
    <Modal.Header>
      {(context) => (
        <Fragment>
          <ButtonIcon
            className="close"
            transparent
            type="secondary"
            icon="close"
            onClick={context.actions.closeModal}
          />
          <h2 className="modal_title _tw-text-sm">
            <I18n label="general.comments" />
          </h2>
        </Fragment>
      )}
    </Modal.Header>
  );

  renderContextAnswers = (item) => {
    const { commentSelected = {} } = this.props;
    const { showMoreComments, answerListText, answerBoxOpened } = this.state;
    const highlighted = commentSelected.id === item.id;

    return (
      <CommentChat
        item={item}
        commentStatusUpdate={this.commentStatusUpdate}
        isTopic={false}
        userNameEmail={CommunityService.getUsernameEmail(item)}
        showUserPhoto
        showStatus
        highlighted={highlighted}
        showMoreComments={showMoreComments}
        answerBoxOpened={answerBoxOpened}
        answerListText={answerListText}
        showMore={this.showMore}
        toogleAnswer={this.toogleAnswer}
        onAnswerText={this.onAnswerText}
        commentAnswerReply={this.commentAnswerReply}
      />
    );
  };

  navigateToAcademy = () => {
    const { topicComment } = this.state;

    CommunityService.redirectClassAcademy(topicComment);
  };

  renderContextHeader() {
    return (
      <div className="_d-flex _flex-column _flex-sm-row _align-items-sm-center _mb-4">
        <span className="_mt-1 _mt-sm-0">
          <I18n label="community.comment_context" />
        </span>
        <div className="_d-flex _flex-column _align-items-start _flex-sm-row _align-items-sm-center _justify-content-sm-end _mt-5 _mt-sm-0 _flex-sm-grow-1 _pl-sm-3">
          {this.viewAsProducerIsAllowed && (
            <Button
              variation="secondary"
              size="sm"
              onClick={this.navigateToAcademy}
              className="_mr-2"
            >
              <I18n label="community.see_all_topic_comments" />
            </Button>
          )}
          <Button
            variation="secondary"
            size="sm"
            onClick={this.redirectHistoricScreen}
          >
            {this.historicTitle}
          </Button>
        </div>
      </div>
    );
  }

  showMoreComments() {
    return (
      <Button
        variation="secondary"
        onClick={this.getMoreComments}
        className="_align-self-center"
      >
        <I18n label="community.load_more_comments" />
      </Button>
    );
  }

  renderTopicTitle = (label) => {
    const { t } = this.props;

    return (
      <div className="_d-flex _d-md-none _align-items-center _font-weight-bold _line-height-lg _mt-5 _mb-3">
        <FontAwesomeIcon icon={['fal', 'message']} className="_mr-2" />
        <span>{t(label)}</span>
      </div>
    );
  };

  renderModalBody() {
    const { commentSelected = {} } = this.props;
    const {
      contextCommentList,
      topicComment,
      loadMoreComments,
      showMoreComments,
      loading,
      answerBoxOpened,
      answerListText
    } = this.state;
    const highlighted = commentSelected.id === topicComment.id;

    return (
      <Modal.Body
        scrollable
        modal
        modalRef={this.modalRef}
        className="_d-flex _flex-column"
      >
        {this.renderContextHeader()}
        {this.renderTopicTitle('community.actions.topic')}
        <div className="sm:_mt-5">
          <CommentChat
            isTopic={false}
            showStatus
            showUsernameEmail
            showUserPhoto
            item={topicComment}
            commentStatusUpdate={this.commentStatusUpdate}
            userNameEmail={CommunityService.getUsernameEmail(topicComment)}
            highlighted={highlighted}
            showMoreComments={showMoreComments}
            answerBoxOpened={answerBoxOpened}
            answerListText={answerListText}
            showMore={this.showMore}
            toogleAnswer={this.toogleAnswer}
            onAnswerText={this.onAnswerText}
            commentAnswerReply={this.commentAnswerReply}
          />
        </div>
        {this.renderTopicTitle('general.answers')}
        <div className="_ml-0 _ml-md-8">
          {contextCommentList.map(this.renderContextAnswers)}
        </div>
        {loadMoreComments && this.showMoreComments()}
        {loading && (
          <Loader key="loader" className="comment-list__loader--fixed" mask />
        )}
      </Modal.Body>
    );
  }

  render() {
    const { onClose } = this.props;

    return (
      <Modal onClose={onClose} className="comment-list__context-modal">
        {this.renderModalHeader()}
        {this.renderModalBody()}
      </Modal>
    );
  }
}

export default translate()(
  inject((stores) => ({ hash: stores.UserStore.hash }))(
    withRouter(observer(ContextModal))
  )
);
